module.exports = __webpack_public_path__ + "img/pink-mask-sm.894093bb.svg";